import React from 'react'
import './style.scss';

export const Skeleton = () => {
    return(
        <div className="skeleton"></div>
    );
}

export default Skeleton;